import { DEFAULT_BACKGROUND } from './board.js';
/**
 * Schriftstapel, die ohne Nachladen funktionieren.
 *
 * Bewusst keine Webfonts: Die Anwendung liefert eine strenge CSP aus und läuft
 * auf einem eigenen Server ohne CDN. Eine Schrift, die erst geladen werden muss,
 * wäre im Vortrag genau dann nicht da, wenn es darauf ankommt.
 */
export const FONTS = {
    sans: {
        label: 'font.sans',
        stack: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
    },
    serif: {
        label: 'font.serif',
        stack: "'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, 'Times New Roman', serif",
    },
    grotesk: {
        label: 'font.grotesk',
        stack: "'Helvetica Neue Condensed', 'Arial Narrow', 'Roboto Condensed', Impact, sans-serif",
    },
    mono: {
        label: 'font.mono',
        stack: "ui-monospace, SFMono-Regular, Menlo, Consolas, 'Liberation Mono', monospace",
    },
    rounded: {
        label: 'font.rounded',
        stack: "'Avenir Next', Avenir, 'Segoe UI', system-ui, 'Trebuchet MS', sans-serif",
    },
};
export const FONT_KEYS = Object.keys(FONTS);
export const DEFAULT_THEME = {
    palette: ['#f2eee6', '#0b0b0d', '#e8622e', '#2e8ce8', '#22a06b', '#d6a127'],
    headingFont: 'serif',
    bodyFont: 'sans',
};
export const DEFAULT_ORG_DESIGN = {
    background: DEFAULT_BACKGROUND,
    theme: DEFAULT_THEME,
};
export const isFontKey = (value) => typeof value === 'string' && value.length > 0 && value.length <= 80;
/**
 * Schriftstapel zu einem Schlüssel.
 *
 * Unbekannte Schlüssel sind selbst gehostete Familien — sie bekommen die
 * Grundschrift als Rückfall, damit ein noch nicht geladenes WOFF2 nie zu einer
 * unlesbaren Seite führt.
 */
export const fontStack = (key) => {
    const builtIn = FONTS[key];
    if (builtIn)
        return builtIn.stack;
    return `"${key.replace(/"/g, '')}", ${FONTS.sans.stack}`;
};
/**
 * Gängige Familien für die Schriftsuche. Ein vollständiger Katalog bräuchte
 * einen API-Schlüssel bei Google; diese Auswahl deckt ab, was in
 * Präsentationen tatsächlich vorkommt — eigene Namen sind trotzdem möglich.
 */
export const GOOGLE_FONT_SUGGESTIONS = [
    'Inter',
    'Roboto',
    'Open Sans',
    'Lato',
    'Montserrat',
    'Poppins',
    'Source Sans 3',
    'Nunito',
    'Nunito Sans',
    'Work Sans',
    'Rubik',
    'Manrope',
    'DM Sans',
    'Outfit',
    'Figtree',
    'Plus Jakarta Sans',
    'Space Grotesk',
    'Karla',
    'Barlow',
    'Mulish',
    'Playfair Display',
    'Merriweather',
    'Lora',
    'Libre Baskerville',
    'Source Serif 4',
    'Crimson Pro',
    'EB Garamond',
    'Cormorant Garamond',
    'Spectral',
    'DM Serif Display',
    'Bitter',
    'Frank Ruhl Libre',
    'Oswald',
    'Bebas Neue',
    'Archivo',
    'Anton',
    'Fira Sans',
    'IBM Plex Sans',
    'IBM Plex Serif',
    'IBM Plex Mono',
    'JetBrains Mono',
    'Space Mono',
];
/** Sechs Plätze, damit die Palette in jedem Wähler gleich aussieht. */
export const PALETTE_SLOTS = 6;
//# sourceMappingURL=theme.js.map